(function () {
  let lock = false;

  function isSizeFacetInput(el) {
    if (!el || el.tagName !== "INPUT") return false;
    if (el.type !== "checkbox") return false;

    const name = (el.getAttribute("name") || "").toLowerCase();
    return name.includes("filter") && name.includes("option.size");
  }

  // Só 1 size de cada vez: ao marcar um, desmarca os outros
  document.addEventListener("change", function (e) {
    const input = e.target;
    if (!isSizeFacetInput(input)) return;
    if (lock) return;

    // se desmarcou, ok
    if (!input.checked) return;

    lock = true;

    const scope =
      input.closest("#facets-drawer form") ||
      input.closest("form.facets") ||
      input.closest("facets-form form") ||
      document;

    const all = scope.querySelectorAll('input[type="checkbox"]');

    all.forEach((el) => {
      if (el !== input && isSizeFacetInput(el) && el.checked) {
        el.checked = false;
      }
    });

    lock = false;
  });

  // clicar no size já selecionado para limpar
  document.addEventListener("click", function (e) {
    const label = e.target.closest("#facets-drawer .rh-size-label, .facets .rh-size-label");
    if (!label) return;

    const forId = label.getAttribute("for");
    if (!forId) return;

    const input = document.getElementById(forId);
    if (!isSizeFacetInput(input)) return;

    if (input.checked) {
      e.preventDefault();
      input.checked = false;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
})();